import { Box, Typography } from '@mui/material';
import type { TLandingCapability } from '../landing-content';

/** One numbered capability tile. */
export function CapabilityCard(props: { capability: TLandingCapability }) {
  return (
    <Box
      component="article"
      sx={{
        minHeight: { xs: 220, sm: 265 },
        p: 3,
        background: 'linear-gradient(180deg, rgba(255,255,255,.025), rgba(255,255,255,.008))',
      }}
    >
      <Typography
        component="span"
        sx={{ display: 'block', mb: { xs: 4, sm: 6 }, color: '#828282', fontSize: '.78rem' }}
      >
        {props.capability.number}
      </Typography>
      <Typography variant="h3" component="h3" sx={{ mb: 1.5 }}>
        {props.capability.title}
      </Typography>
      <Typography sx={{ color: 'text.secondary' }}>{props.capability.description}</Typography>
    </Box>
  );
}
